"use client";
import Steps from "./_components/Steps";
import Header from "@/components/shared/Header";
// import Footer from "@/components/shared/Footer";
import TelegramLogin from "@/components/HomeComponents/TelegramLogin";
import React, { useEffect } from "react";
import { getCookie } from "cookies-next";
import { useRouter } from "next/navigation";
import AdPannerFooter from "@/components/shared/AdPannerFooter/AdPannerFooter";
// import { Metadata } from "next";

// export const metadata: Metadata = {
//   title: "إنشاء الحساب",
// };

const page = () => {
  const router = useRouter();
  useEffect(() => {
    const token = getCookie("seveezToken");
    const tokenTwo = getCookie("Education_User_token");
    if (token && tokenTwo && token === tokenTwo) {
      router.push("/dashboard");
    }
  }, []);

  return (
    <div>
      <Header />
      <div className=" container my-16 flex flex-col gap-5">
        <Steps />
      </div>
      {/* <Footer />
<TelegramLogin /> */}
      {/* <AdPannerFooter /> */}
    </div>
  );
};

export default page;
